module.exports = __webpack_public_path__ + "img/logo.f9b1581b.png";